import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import trackerConfig from "../Tracker_Common/TrackerConfig.json";
import CustomDropdown from "../../../CustomControls/dropdown";
import MultiSelectDropdown from "../../../CustomControls/MultiSelectDropdown";
import { Endpoints } from "../../../Global/Endpoints";
import { useTranslation } from 'react-i18next';

Modal.setAppElement("#root");

const CreateNotesModal = ({ isOpen, onClose, trackerType, selectedDate }) => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({});
  const [validationError, setValidationError] = useState(""); // To store validation error message
  const [isUpdateMode, setIsUpdateMode] = useState(false); // Track if this is an update
  const trackerData = trackerConfig[trackerType] || {};
  const token = localStorage.getItem("AccessToken");
  const email = useSelector((state) => state.email.email);
  const [validationErrors, setValidationErrors] = useState({}); // To store validation error messages
  const deviceType = "PatientPortal";
  const fieldMapping = {
    fertility: {
      Notes: "Notes",
      Period: "Period",
      "Sex Drive": "SexDrive",
      Intercourse: "SexualActivity",
      Symptoms: "PersonalSymptoms",
      Mood: "Mood",
    },
    Andropause: {
      Notes: "Notes",
      "Sex Drive": "SexDrive",
      Intercourse: "SexualActivity",
      Symptoms: "PersonalSymptoms",
      Mood: "Mood",
    },
    menopause: {
      Notes: "Notes",
      Period: "Period",
      "Sex Drive": "SexDrive",
      Intercourse: "SexualActivity",
      Symptoms: "PersonalSymptoms",
      Mood: "Mood",
    },
    pregnancy: {
      Notes: "Notes",
      Skin: "Skin",
      "Sex Drive": "SexDrive",
      Stress: "Stress",
      Symptoms: "PersonalSymptoms",
      Mood: "Mood",
    },
  };

  // Fetch event data if it exists for the selected date
  useEffect(() => {
    const fetchEventData = async () => {
      if (selectedDate && email) {
        const params = { EmailID: email, Date: selectedDate.toLocaleDateString("en-US"),DeviceType: deviceType};
        try {
          const response = await axios.post(
           Endpoints.LoadReminderEventData,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.data && response.data.Events && response.data.Events.EventID) {
            const eventData = response.data.Events;
            setFormData({
              Intercourse: eventData.SexualActivity || "",
              "Sex Drive": eventData.SexDrive || "",
              Mood: eventData.Mood || "",
              Notes: eventData.Notes || "",
              Symptoms: eventData.PersonalSymptoms || "",
              Period: eventData.Period || "",
              EventID: eventData.EventID, // Store EventID for update
              Skin:eventData.Skin || "",
              Stress:eventData.Stress||""
            });
            setIsUpdateMode(true); // Enable update mode
          } else {
            setFormData({}); 
            setValidationError("");// Clear for new entry mode
            setIsUpdateMode(false);
          }
        } catch (error) {
          console.error("Error fetching event data:", error);
        }
      }
    };

    if (isOpen) {
      fetchEventData();
    }
  }, [isOpen, selectedDate, email, token]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setValidationError(""); // Clear error when input changes
  };

  const handleMultiSelectChange = (field, selectedList) => {
    setFormData((prev) => ({
      ...prev,
      [field]: selectedList.map((item) => item.name).join(", "),
    }));
    setValidationError(""); // Clear error when input changes
  };

  // const handleSaveNote = async () => {
  //   const hasRequiredField = trackerData.fields.some((field) => formData[field.label]);

  //   if (!hasRequiredField) {
  //     setValidationError("Please select at least one option to save the note.");
  //     return; // Stop execution if there are validation errors
  //   }

  //   const payload = {
  //     Medications: "",
  //     EventDate: selectedDate?.toLocaleDateString("en-US") || "",
  //     EventID: formData.EventID || "", // Include EventID for update
  //     PregnancyTests: "",
  //     SexualActivity: formData["Intercourse"] || "",
  //     EmailID: email,
  //     SexDrive: formData["Sex Drive"] || "",
  //     Mood: formData["Mood"] || "",
  //     OvulationTests: "",
  //     Notes: formData["Notes"] || "",
  //     PersonalSymptoms: formData["Symptoms"] || "",
  //     Period: formData["Period"] || "",
  //     Skin:"",
  //     Stress:""
  //   };

  //   try {
  //     const response = await axios.post(
  //       "https://devtrackerapp.winfertility.com/api/Event/SaveEvent",
  //       `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/x-www-form-urlencoded",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response.data && response.data.Message === "Successfully Saved" && response.data.Result === 1) {
  //       toast.success(isUpdateMode ? "Note updated successfully!" : "Note created successfully!");
  //       setFormData({}); // Clear the form after successful save or update
  //       setIsUpdateMode(false); // Reset update mode
  //     } else {
  //       toast.error("Failed to save data. Please try again.");
  //     }      
  //   } catch (error) {
  //     console.error("Error during save:", error);
  //     toast.error("An error occurred while saving data.");
  //   }
  //   onClose(); // Close modal
  // };
  const handleSaveNote = async () => {
    const hasRequiredField = trackerData.fields.some((field) => formData[t(field.label)]);
    if (!hasRequiredField) {
      setValidationError(t("createnotesvalidation"));
      return;
    }

    // Build the payload dynamically based on the tracker type
    const mapping = fieldMapping[trackerType];
    const payload = {
      Medications: "",
      EventDate: selectedDate?.toLocaleDateString("en-US") || "",
      EventID: formData.EventID || "",
      PregnancyTests: "",
      OvulationTests: "",
      EmailID: email,
      SexualActivity:formData["SexualActivity"]||"",
      Period:formData["Period"] || "",
      DeviceType: deviceType
    };
    // Add mapped fields from formData to the payload
    for (const [formField, apiField] of Object.entries(mapping)) {
      payload[apiField] = formData[formField] || "";
    }
    try {
      const response = await axios.post(
        Endpoints.SaveEvent,
        `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.Message === "Successfully Saved" && response.data?.Result === 1) {
        setTimeout(() => {
        toast.success(isUpdateMode ?t("createnoteupdatemessage") : t("createnotesavemessage"));
        }, 500);
        setFormData({});
        setIsUpdateMode(false);
      } else {
        toast.error(t("createnoteserrormessage"));
      }
    } catch (error) {
      toast.error(t("createnoteserrorsaving"));
    }
    onClose();
  };
  const handleCloseModal = () => {
    setFormData({}); // Clear form data on modal close
    setValidationError("");
    setIsUpdateMode(false); // Reset update mode on close
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        contentLabel="Create Notes Modal"
        className="tracker-modal-content"
        overlayClassName="tracker-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <h2>{t(trackerData.title)}</h2>
        <div className="model-form-wrapper">
          {trackerData.fields.map((field, index) => (
            <div className="mb-4 row align-items-center" key={index}>
              <label className="col-sm-4 model-form-label">{t(field.label)}</label>
              <div className="col-sm-6 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
                {field.type === "textarea" && (
                  <textarea
                    placeholder={t(field.placeholder)}
                    value={formData[t(field.label)] || ""}
                    className="form-control win-form-control textarea-control  mobile-view-important"
                    rows="4"
                    onChange={(e) => handleChange(t(field.label), e.target.value)}
                    maxLength={250}
                  />
                )}
                {t(field.type) === "dropdown" && !t(field.checkboxOptions) && (
                 <CustomDropdown
                 onChange={(value) => handleChange(t(field.label), value)} // Pass the selected value directly
                 selectedOption={formData[t(field.label)] || ""} // Selected value from formData
                 placeholder={t(field.placeholder)} // Placeholder for the dropdown
                 options={field.options.map((option) => t(option))} // Translate each option to a string
               />
                )}
                {t(field.type) === "dropdown" && t(field.checkboxOptions) && (
          <MultiSelectDropdown
          options={field.checkboxOptions.map((option) => ({ name: t(option), id: t(option) }))} // Convert options to objects with name and id
          label={t(field.label)} // Pass the label to the dropdown
          searchable={true} // Enable the search functionality if needed
          selectedValues={
            (formData[t(field.label)] || "")
              .split(", ")
              .filter((item) => item) // Filter out empty strings
              .map((item) => ({ name: item, id: item })) // Convert selected values to objects with name and id
          }
          onSelect={(selectedOption, updatedList) => {
            // Ensure updatedList is always an array
            if (Array.isArray(updatedList)) {
              handleMultiSelectChange(
                t(field.label), // Use untranslated field label for formData
                updatedList
              );
            }
          }}
          onRemove={(removedOption, updatedList) => {
            // Ensure updatedList is always an array
            if (Array.isArray(updatedList)) {
              handleMultiSelectChange(
                t(field.label), // Use untranslated field label for formData
                updatedList
              );
            }
          }}
          
          placeholder={formData[t(field.label)] && formData[t(field.label)].trim() ? "" : t(field.placeholder)} // Placeholder logic
        />
        
          
               
                )}
                {validationErrors[field.label] && (
                  <small className="text-danger">{validationErrors[field.label]}</small>
                )}
              </div>
            </div>
          ))}
          {validationError && (
          <div className="mb-3 row">
            <div className="col-sm-4"></div>
            <div className="col-sm-8">
              <span className="text-danger">{validationError}</span>
            </div>
          </div>
        )}
        <div className="mb-4 row">
          <div className="col-sm-4"></div>
          <div className="col-sm-8">
            <button onClick={handleCloseModal} className="win-btn-secondary btn-w-180px model-popup-btn me-2 mb-3 mb-sm-0">
              {t("Cancel")}
            </button>
            <button onClick={handleSaveNote} className="win-btn-primary btn-w-180px model-popup-btn">
              {isUpdateMode ? t("UpdateNote") : t("SaveNote")}
            </button>
          </div>
        </div>
        </div>
        
      </Modal>
<ToastContainer/>
    </>
  );
};

export default CreateNotesModal;
